module.exports = __webpack_public_path__ + "img/chat_coupon.png?c86959ea8aebe2d05f1f77c40a6d95ad";